import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { CurrenciesListQuery } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const QUERY_CURRENCIES_LIST = gql`
    query currenciesList {
        currencies {
            nodes {
                currencyCode
                description
            }
        }
    }
`;

export const queryCurrencyList = async (client: ApolloClient<NormalizedCacheObject>) => {
    
    const { data, errors } = await client.query<CurrenciesListQuery>({
        query: QUERY_CURRENCIES_LIST,
    });

    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console.
            console.error(error);
        });
        // Friendly error to the user.
        throw new Error('An error has occurred during the query.');
    }

    return data?.currencies?.nodes;
};